/**
 * One URL form for every prerendered SEO route (docs/SEO_OPTIMIZATION_1027.md).
 *
 * Prerender writes build/<route>/index.html, and Netlify answers `/route` with a
 * 301 to `/route/` (the directory form), so `/route/` is the only URL that
 * returns 200 directly. Canonical, og:url, hreflang, sitemap <loc>, JSON-LD and
 * crawler-shell links all use that form. The homepage stays `${SITE}/`.
 * Keep in sync with canonicalUrl() in scripts/seo-meta.mjs (unit-tested).
 */
export const SITE = 'https://cfamockexam.com';

/** '/pricing' → '/pricing/', '/glossary?formulas=1' → '/glossary/?formulas=1'. '/' unchanged. */
export function withSlash(href) {
  const [, path, rest] = String(href || '/').match(/^([^?#]*)(.*)$/);
  if (!path || path === '/' || path.endsWith('/')) return `${path || '/'}${rest}`;
  return `${path}/${rest}`;
}

/** Absolute canonical URL for a route path (query and hash dropped). */
export function canonicalUrl(path = '/') {
  const clean = String(path || '/').split(/[?#]/)[0] || '/';
  return `${SITE}${withSlash(clean)}`;
}
